import T from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink, withRouter } from 'react-router';
import { colors, Icon, unit } from '@acast/decibel';
import { GlobeLightGlyph, AcastAccessGlyph } from '@acast/decibel-glyphs';

const Container = styled.nav`
  display: flex;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
`;

const Link = styled(RouterLink)`
  background-clip: padding-box;
  background-color: ${({ selected }) => (selected ? colors.white : colors.whiteAlpha72)};
  border-bottom: ${({ selected }) => (selected ? 0 : '2px solid transparent')};
  border-right: 2px solid transparent;
  border-radius: 4px 4px 0px 0px;
  color: ${({ selected }) => (selected ? colors.black48 : colors.black72)};
  font-size: 12px;
  font-weight: 500;
  padding: 16px;
  text-transform: uppercase;
  text-decoration: none;

  &:last-child {
    border-right: 0;
  }
`;

const LinkTitle = styled.span`
  margin-left: ${unit(2)};
`;

const ShowSettingsTabNavigation = ({ params, routes }) => {
  const filteredRoutes = routes.filter(route => route.path);
  const currentPath = filteredRoutes[filteredRoutes.length - 1].path;

  return (
    <Container>
      <Link selected={currentPath !== 'access'} to={`/shows/${params.showId}/settings`}>
        <Icon glyph={GlobeLightGlyph} size="12px" />
        <LinkTitle>General Settings</LinkTitle>
      </Link>
      <Link selected={currentPath === 'access'} to={`/shows/${params.showId}/settings/access`}>
        <Icon glyph={AcastAccessGlyph} size="12px" />
        <LinkTitle>Acast Access Settings</LinkTitle>
      </Link>
    </Container>
  );
};

ShowSettingsTabNavigation.propTypes = {
  params: T.shape({
    showId: T.string.isRequired,
  }).isRequired,
  routes: T.arrayOf(
    T.shape({
      path: T.string,
    })
  ).isRequired,
};

export default withRouter(ShowSettingsTabNavigation);
